import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  actionCard: {
    cursor: 'pointer',
    marginTop: 30,
  },
  hero: {
    backgroundColor: theme.palette.grey2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
    padding: '24px 16px',
    borderRadius: '5px',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
    [theme.breakpoints.only('md')]: {
      padding: '32px 24px',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '48px 24px',
    },
  },
  heroBody: {
    zIndex: 0,
    width: '100%',
  },
  logoRoyalUp: {
    marginBottom: '16px',
  },
  row: {
    display: 'flex',
    flexDirection: 'column',
    '& p': {
      color: 'white',
      margin: 0,
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  containerDescription: {
    marginBottom: '24px',
    ' & p': {
      fontSize: theme.typography.pxToRem(16),
    },
    '& > div:first-child p': {
      fontWeight: '600',
      marginBottom: '8px',
    },
    '& > div:last-child p': {
      maxWidth: '400px',
    },
    [theme.breakpoints.up('sm')]: {
      margin: '0',
    },
  },

  buttonSection: {
    textAlign: 'center',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: 250,
      marginLeft: 'auto',
    },
  },

  button: {
    float: 'right',
    lineHeight: '27px',
    height: 50,
    fontSize: theme.typography.pxToRem(18),
    [theme.breakpoints.between('sm', 'md')]: {
      height: '50px',
    },
    '& span': {
      padding: '5px 0px',
      fontSize: theme.typography.pxToRem(16),
      [theme.breakpoints.between('md', 'lg')]: {
        fontSize: theme.typography.pxToRem(18),
        lineHeight: theme.typography.pxToRem(18),
      },
    },
  },

  backgroundImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
    top: '0',
    left: '0',
    borderRadius: '5px',
  },
  gradientOverlay: {
    background: `linear-gradient(89deg, ${theme.palette.blue1} -50%, rgba(255, 125, 125, 0.00) 233.86%)`,
    [theme.breakpoints.up('md')]: {
      background: `linear-gradient(90deg, ${theme.palette.blue1} -40%, rgba(255, 125, 125, 0.00) 106.43%)`,
    },
    content: "''",
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    pointerEvents: 'none',
    borderRadius: '5px',
  },
  fallbackImg: {
    borderRadius: '5px',
    objectPosition: 'top',
  },
}));

export default useStyles;
